import { useEffect } from 'react'
import { hydrateOnChainLaunches } from '@/lib/launchpad/hydrate'
import { listSimLaunches } from '@/lib/launchpad/store'
import { applyLiveListingReset } from '@/lib/liveReset'
import { hydrateOnChainPresales } from '@/lib/presale/hydrate'
import { listSimPresales } from '@/lib/presale/store'
import { prefetchProjectLinks } from '@/lib/projectLinks'

function prefetchListingLinks() {
  prefetchProjectLinks([
    ...listSimLaunches().flatMap(launch => [launch.contractAddress, launch.shareSlug, launch.id, launch.tokenAddress]),
    ...listSimPresales().flatMap(presale => [presale.contractAddress, presale.shareSlug, presale.id, presale.tokenAddress]),
  ])
}

export function useOnChainListings() {
  useEffect(() => {
    let cancelled = false

    const run = async () => {
      try {
        applyLiveListingReset()
        prefetchListingLinks()
        await Promise.all([hydrateOnChainLaunches(), hydrateOnChainPresales()])
        if (!cancelled)
          prefetchListingLinks()
      }
      catch {
        if (!cancelled)
          return
      }
    }

    void run()
    const timer = window.setInterval(() => {
      void run()
    }, 15_000)

    return () => {
      cancelled = true
      window.clearInterval(timer)
    }
  }, [])
}
